import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import ShippingLabelsTable from './ShippingLabelsTable'
import { SHIPPING_LABEL_STATUSES } from './constants'

// coverageReassignment: { from_carrier_name } when the coverage retry swapped the carrier because the
// original one did not cover the postal code (GET /orders/wms/:id), so whoever reprints the label
// knows why it names another carrier.
const ShippingLabelsListSection = ({ shippingLabels, meliShipmentId, coverageReassignment = null, onPrintLabel = labelFile => {}, isHidden = false }) => {
  const { i18n } = useTranslation()
  const validShippingLabels = useMemo(
    () => shippingLabels?.filter(({ status, label_file }) => status === SHIPPING_LABEL_STATUSES.VALID && label_file),
    [shippingLabels],
  )

  if (isHidden) return <></>

  return (
    <section className="bg-white rounded-lg flex flex-col gap-4 pb-2">
      <div className="m-4">
        <h2 className="mb-0 text-2xl font-bold">{`Guías generadas`}</h2>
        <p className="mb-0 text-lg">{'Ya se han generado guías para esta orden'}</p>
        {coverageReassignment && (
          <p className="mb-0 mt-2 text-base text-gray-600">
            {i18n.t('generate_shipment.coverage_reassignment_notice', { from: coverageReassignment.from_carrier_name })}
          </p>
        )}
      </div>

      <div className="max-h-40 overflow-y-auto">
        <ShippingLabelsTable validShippingLabels={validShippingLabels} meliShipmentId={meliShipmentId} onPrintLabel={onPrintLabel} />
      </div>
    </section>
  )
}

export default ShippingLabelsListSection
